import { Chip } from "@mui/material";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { ALBUM_ACCESSIBILITY } from "./album-utils";

const AlbumAccessibility = ({ album }) => {
  const intl = useIntl();

  return (
    <Chip
      color={ALBUM_ACCESSIBILITY[album.privacy].color}
      label={ALBUM_ACCESSIBILITY[album.privacy].short}
      title={ALBUM_ACCESSIBILITY[album.privacy].description}
      size="small"
      sx={{ color: "white" }}
      icon={ALBUM_ACCESSIBILITY[album.privacy].icon}
    />
  );
};

AlbumAccessibility.propTypes = {
  album: PropTypes.object.isRequired,
};

export default AlbumAccessibility;
